import {
  SET_MEASURE_WORKFLOW
} from '../actions';

export default function (state = {}, action) {

  switch(action.type) {
    case SET_MEASURE_WORKFLOW:
      return action.payload;

    default:
      return state;
  }
}